import {Button} from 'antd-mobile'

class FliterMenu extends React.Component {
    render() {
        let that = this;
        const {current,isOpen,datas,name,defaultName,scrollHeight} = this.props;
        const lineCount = document.documentElement.clientWidth > 640 ? 4 : 3;
        let lines = new Array();
        let buttons = new Array();
        let nowDatas = datas || [];
        for(let i=0;i<nowDatas.length;i++) {
            let nowData = nowDatas[i];
            buttons.push(
            	<div className="csm-filter-menu-button" style={{width: 100 / lineCount + '%'}}>
	                <Button size="small" inline onClick={that.onSelected.bind(this,nowData.value,nowData.label)} type={current===nowData.value?"primary":"default"}>
	                    {nowData.label}
	                </Button>
                </div>
            );
            if((i + 1) % lineCount == 0 || i == nowDatas.length-1) {
                lines.push(<div className="csm-filter-menu-buttons-line">{buttons}</div>)
                buttons = new Array();
            }
        }
        return (
            <div className="csm-filter-menu-option">
	            <div className={"csm-filter-menu-select"+(isOpen?" on":"")} onClick={that.onClick.bind(this)}>
	                <a>{current===""?defaultName:name}</a>
	            </div>
	            <div className={'csm-filter-menu-buttons-mask'+(isOpen?" on":"")} style={{height: isOpen ? scrollHeight : 0}} >
		            <div className={"csm-filter-menu-buttons"+(isOpen?" on":"")} style={{height:isOpen ? (0.4 + 0.9 * lines.length)+"rem" : 0}}>
	                    {lines}
		            </div>
	            </div>
            </div>
        )
    }
    onClick() {
        if(typeof this.props.onClick === "function")
            this.props.onClick();
    }
    onSelected(id,name) {
        if(typeof this.props.onSelected === "function")
            this.props.onSelected(id,name);
    }
}

export default FliterMenu


// WEBPACK FOOTER //
// ./project/components/apps/FliterMenu.js